export default {
  termsOfUse: 'Condiciones de Uso',
  privacyPolicy: 'Política de Privacidad',
  cookiesPolicy: 'Política de Cookies',
  careers: 'Oportunidades laborales',

  connectSocialMedia: 'Conéctate en las redes sociales',
  copyright: 'Copyright',
  mtgAllRightsReserved: 'Cactus Communications. All rights reserved',
};
